export const BASE_URL = "http://phplaravel-268854-2244987.cloudwaysapps.com/api/v1/articles";
export const DOMAIN_URL = "apdp-helice.netlify.app"